import EA from '../helpers/init';


export default EA.Methods.mobileMenu = ($this) => {
    const mobileMenu = document.querySelector('.mobile-menu-wrapper');
    const activation = $this.querySelector('.mobile-menu');
    const close = mobileMenu.querySelector('.close');

    activation.addEventListener('click', () =>{
        mobileMenu.classList.add('active');
    });

    close.addEventListener('click', () =>{
        mobileMenu.classList.remove('active');
    });
};
